export default {
  exchangeTitle: '換匯',
  accountNumberTitle: '賬戶',
  exchangeCurrency: '換匯貨幣',
  exchangeTo: '兌換至',
  exchangeRate: '匯率',
  referenceRate: '參考匯率',
  swapLines: '可兌換金額',
  swapAmount: '兌換金額',
  errorSwapAmount: '請填寫正確的換匯金額！ ',
  inputSwapAmountTips: '請填寫換匯金額！ ',
  selectTradeAccountTips: '請選擇交易賬戶',
  toCurrency: '兌換幣種',
  noExchange: '無換匯記錄',
  errMsg: {
    '10001': '獲取換匯記錄失敗',
    '10002': '初始化交易賬戶選項失敗'
  },
  tips: {
    '10001': '請輸入兩位小數點的數字',
    '10002': '兌換金額不得大於可兌換額度'
  },
  exchangeDirection: '兌換方向',
  cashOut: '兌出',
  cashIn: '兌入',
  exchangeAll: '全部兌換',
  lockOut: '鎖定兌出金額',
  lockOutTips: '若選擇鎖定兌出金額，系統將以最終匯率計算出兌入幣種之金額。換言之，系統會確保最終兌出之金額為客戶輸入之數值。兌入幣種所得之金額，將會以最終匯率來計算。 ',
  lockIn: '鎖定兌入金額',
  lockInTips: '若選擇鎖定兌入金額，系統將以最終匯率計算出兌出幣種之金額。若可兌換金額足夠，系統將確保兌入之金額為客戶輸入之數值。若因為匯率之浮動引致可兌換金額不足，系統會將可兌換金額全數提取，以兌換成兌入幣種之數值。 ',
  example1: '例一: 可兌換金額足夠',
  exampleTip1: '客戶之港元可兌換金額為HKD 78,315<br> 參考匯率為7.8305港幣 = 1美元<br>客戶鎖定兌入10,000美元<br>若最終之匯率與參考匯率一致，則系統計算出之兌出金額為HKD 78,305，客戶之港元可兌換金額足夠。 ',
  example2: '例二: 可兌換金額不足',
  exampleTip2: '承上例子，若最終匯率變成7.8405港幣 = 1美元，則所需兌出金額為HKD 78,405。<br>此時客戶之可兌出金額不足，系統將兌出全數HKD 78,315，兌換成USD 9,988.52 ( 78,315 / 7.8405 )。',
  info:
  ` 1. 貨幣兌換支持7×24小時全天候辦理。對於未能即時順利辦理的申請，將由專人於工作日辦公時間內跟進處理。 <br />
    2. 結單顯示規則 <br />
    （以下均為香港時間） <br />
    <span style="color:#333;font-weight:500;">(I) 證券/基金賬戶：</span>客戶於每日16:59或之前辦理完成的貨幣兌換將反映在當日的結單；其後完成的貨幣兌換將顯示在下一交易日的結單。 <br />
    <span style="color:#333;font-weight:500;">(II) 期貨賬戶：</span>客戶於星期一至五（元旦除外）06:00至翌日05:59期間辦理完成的貨幣兌換將反映在當日的結單；於星期六05:59後辦理完成的貨幣兌換將顯示在下一交易日的結單。 <br />
    備註：若貨幣兌換於每年元旦當日辦理完成，相關記錄將顯示在下一交易日的結單。 <br />
    3. 匯率頁面僅供參考，實際的兌換匯率會隨外匯牌價變化。 <br />
    4. 若賬戶内存在未完成結算和交收的資金，有關資金暫不支持兌換。`
}
